<script>
import Layout from '../../layouts/main';
import PageHeader from '@/components/page-header';
import router from '@/router';
import axios from 'axios';
import Swal from 'sweetalert2';
import moment from 'moment';
import RichTextEditor from '@/components/RichTextEditor.vue';
import { authFackMethods } from '@/state/helpers';
import { required } from 'vuelidate/lib/validators';

export default {
	page: {
		title: 'Approvals',
		meta: [
			{
				name: 'Approval',
			},
		],
	},
	components: {
		Layout,
		PageHeader,
		RichTextEditor,
	},
	props: ['approvalId', 'userId'],
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			currentUserData: JSON.parse(localStorage.getItem('user')),
			tags: null,
			user_id: null,
			confirmApplicationStatus: [],
			characterReferenceConfirmed: [],
			confirmPsvBackgroundStatus: [],
			confirmDhsStatus: [],
			orientationConfirmed: [],
			applicationApproved: [],
			applicationRCS: [],
			applicationCCM: [],
			modalTitle: '',
			locationId: '',
			isLocked: true,
			user_type_id: null,
			is_upgraded: null,
			user_status: null,
			current_task_id: null,
			user_current_status: null,
			review_application: null,
			confirm_application_status: null,
			review_character_references: null,
			character_reference_confirmed: null,
			start_sterling_background_check: null,
			confirm_sterling_background_status: null,
			remove_ss_and_dL: null,
			kickoff_dhs_background_check: null,
			start_dhs_background_check: null,
			confirm_dhs_status: null,
			upload_letter_r_drive: null,
			document_case_details: null,
			dhs_background_check_complete: null,
			schedule_orientation_date: null,
			send_calendar_invite: null,
			send_orientation_confirmation_email: null,
			send_orientation_kickoff_email: null,
			orienation_confirmed: null,
			application_approved: null,
			assign_applicant: null,
			send_approval_email_confirmation: null,
			follow_up_character_reference: null,
			received_character_reference: null,
			send_appilcation_received_email: null,
			send_dhs_orientation_email: null,
			state_id_authorization: null,
			send_fingerprinting_instructions_email: null,
			initiate_netstudy_for_fingerprinting: null,
			check_fingerprinting_status: null,
			confirm_fingerprinting_with_applicant: null,
			fingerprinting_completed: null,
			assigned_to_programs: null,
			send_assignment_email_to_mentor_ccm: null,
			email_applicant_background_info_to_ccm: null,
			send_meeting_invite_applicant: null,
			confirm_meeting_date: null,
			document_meeting_date: null,
			review_application_waitlist: null,
			screening_meeting_complete: null,
			introduce_applicant_to_client: null,
			confirm__roi_release_info_signature: null,
			document_introduction_date_client: null,
			send_assignment_email: null,
			feedback_on_assignment: null,
			schedule_first_assignment: null,
			confirm_onboarding_complete: null,
			confirm_assignment_date_role: null,
			request_orientation: null,
			confirm_orientation: null,
			orientation: null,
			approvalForm: {
				user_id: null,
				user_type_id: null,
				user_status: null,
				review_application: null,
				confirm_application_status: null,
				review_character_references: null,
				character_reference_confirmed: null,
				start_sterling_background_check: null,
				confirm_sterling_background_status: null,
				remove_ss_and_dL: null,
				kickoff_dhs_background_check: null,
				start_dhs_background_check: null,
				confirm_dhs_status: null,
				upload_letter_r_drive: null,
				document_case_details: null,
				dhs_background_check_complete: null,
				schedule_orientation_date: null,
				send_calendar_invite: null,
				send_orientation_confirmation_email: null,
				send_orientation_kickoff_email: null,
				orienation_confirmed: null,
				application_approved: null,
				assign_applicant: null,
				send_approval_email_confirmation: null,
				follow_up_character_reference: null,
				received_character_reference: null,
				send_appilcation_received_email: null,
				send_dhs_orientation_email: null,
				state_id_authorization: null,
				send_fingerprinting_instructions_email: null,
				initiate_netstudy_for_fingerprinting: null,
				check_fingerprinting_status: null,
				confirm_fingerprinting_with_applicant: null,
				fingerprinting_completed: null,
				assigned_to_programs: null,
				send_assignment_email_to_mentor_ccm: null,
				email_applicant_background_info_to_ccm: null,
				send_meeting_invite_applicant: null,
				confirm_meeting_date: null,
				document_meeting_date: null,
				review_application_waitlist: null,
				screening_meeting_complete: null,
				introduce_applicant_to_client: null,
				confirm__roi_release_info_signature: null,
				document_introduction_date_client: null,
				send_assignment_email: null,
				feedback_on_assignment: null,
				schedule_first_assignment: null,
				confirm_onboarding_complete: null,
				confirm_assignment_date_role: null,
				request_orientation: null,
				confirm_orientation: null,
				orientation: null,
				due_dates: [],
				comments: [],
			},
			commentForm: {
				user_id: this.user_id,
				approval_id: this.id,
				staff_id: '',
				comment: '',
				type: '',
				via: false,
				status: '',
				user_current_status: '',
				current_task_id: null,
				tag_id: '',
			},
			emailForm: {
				user_id: this.user_id,
				approval_id: this.id,
				type: '',
				staff_id: '',
				to: '',
				comment: '',
				cc: '',
				subject: '',
				rt: '',
			},
			comments: [],
			typeSubmit: false,
			recordNotFound: false,
			isLoading: false,
			mentorTasksSequence: [
				{ label: 'Review Application', key: 'review_application', value: null },
				{
					label: 'Confirm Application Status',
					key: 'confirm_application_status',
					value: null,
				},
				{
					label: 'Start Intellicorps Background Check',
					key: 'start_sterling_background_check',
					value: null,
				},
				{
					label: 'Send Application Received Email',
					key: 'send_appilcation_received_email',
					value: null,
				},
				{
					label: 'Confirm Intellicorps Background Status',
					key: 'confirm_sterling_background_status',
					value: null,
				},
				{ label: 'Remove SS and DL', key: 'remove_ss_and_dL', value: null },
				{
					label: 'Review Character References',
					key: 'review_character_references',
					value: null,
				},
				{
					label: 'Character Reference Confirmed',
					key: 'character_reference_confirmed',
					value: null,
				},
				{
					label: 'Screening Meeting Complete',
					key: 'screening_meeting_complete',
					value: null,
				},
				{
					label: 'Send DHS email',
					key: 'send_dhs_orientation_email',
					value: null,
				},
				{
					label: 'State ID, Authorization Form, Date of Orientation Received',
					key: 'state_id_authorization',
					value: null,
				},
				{
					label: 'Send Fingerprinting instructions email',
					key: 'send_fingerprinting_instructions_email',
					value: null,
				},
				{
					label: 'Start DHS Background Check',
					key: 'start_dhs_background_check',
					value: null,
				},
				{
					label: 'Check Fingerprinting Status',
					key: 'check_fingerprinting_status',
					value: null,
				},
				{
					label: 'Confirm Fingerprinting with Applicant',
					key: 'confirm_fingerprinting_with_applicant',
					value: null,
				},
				{
					label: 'Follow-up on Check Fingerprinting Status',
					key: 'follow_up_on_check_fingerprinting_status',
					value: null,
				},
				{ label: 'Confirm DHS Status', key: 'confirm_dhs_status', value: null },
				{
					label: 'Upload DHS determination letter to R Drive',
					key: 'upload_letter_r_drive',
					value: null,
				},
				{
					label: 'Document Case Details',
					key: 'document_case_details',
					value: null,
				},
				{
					label: 'Application Approved',
					key: 'application_approved',
					value: null,
				},
				{ label: 'Assign Applicant', key: 'assign_applicant', value: null },
				{
					label: 'Schedule Orientation / Intro Meeting',
					key: 'send_calendar_invite',
					value: null,
				},
				{
					label: 'Review Application / Waitlist',
					key: 'review_application_waitlist',
					value: null,
				},
				{
					label: 'Orientation / Intro Meeting Complete',
					key: 'orientation',
					value: null,
				},
				{
					label: 'Confirm (ROI) Release of Information Signature',
					key: 'confirm__roi_release_info_signature',
					value: null,
				},
				{
					label: 'Document Introduction Date/Client',
					key: 'document_introduction_date_client',
					value: null,
				},
				{ label: 'Completed', key: 'completed', value: null },
			],
			volunteerTasksSequence: [
				{ label: 'Review Application', key: 'review_application', value: null },
				{
					label: 'Confirm Application Status',
					key: 'confirm_application_status',
					value: null,
				},
				{
					label: 'Screening Meeting (Phone Call)',
					key: 'request_intro_meeting',
					value: null,
				},
				{
					label: 'Send Application Response and DHS email',
					key: 'send_dhs_orientation_email',
					value: null,
				},
				{
					label: 'State ID, Authorization Form, Date of Orientation Received',
					key: 'state_id_authorization',
					value: null,
				},
				{
					label: 'Send Fingerprinting instructions email',
					key: 'send_fingerprinting_instructions_email',
					value: null,
				},
				{
					label: 'Start DHS Background Check',
					key: 'start_dhs_background_check',
					value: null,
				},
				{
					label: 'Check Fingerprinting Status',
					key: 'check_fingerprinting_status',
					value: null,
				},
				{
					label: 'Confirm Fingerprinting with Applicant',
					key: 'confirm_fingerprinting_with_applicant',
					value: null,
				},
				{
					label: 'Follow-up on Check Fingerprinting Status',
					key: 'follow_up_on_check_fingerprinting_status',
					value: null,
				},
				{ label: 'Confirm DHS Status', key: 'confirm_dhs_status', value: null },
				{
					label: 'Upload DHS determination letter to R Drive',
					key: 'upload_letter_r_drive',
					value: null,
				},
				{
					label: 'Document Case Details',
					key: 'document_case_details',
					value: null,
				},
				{
					label: 'Orientation / Intro Meeting Complete',
					key: 'orientation',
					value: null,
				},
				{
					label: 'Confirm Assignment Date/Role',
					key: 'confirm_assignment_date_role',
					value: null,
				},
				{
					label: 'Schedule first Assignment',
					key: 'schedule_first_assignment',
					value: null,
				},

				{ label: 'Completed', key: 'completed', value: null },
			],
			valid_dhs_statuses: ['DHS Approved', 'Needs More Time - No Supervision', 'Not Required'],
			valid_application_statuses: ['Confirmed', 'Incomplete application', 'Needs Character Reference'],
			valid_sterling_background_statuses: ['PSV Approved', 'In Progress'],
			validResumeApprovalUserTypes: [
				1, // Admin
				6, // MVS Coordinator
				7, // Client Care Manager
				8, // Recovery Coach Supervisor / Volunteer Lead
				10, // Approver
			],
		};
	},
	validations: {
		commentForm: {
			comment: { required },
		},
	},
	mounted() {
		this.user_id = this.userId;
		this.getApproval();
		this.getConfirmApplicationStatus();
		this.getCharacterReferenceConfirmed();
		this.getConfirmPsvBackgroundStatus();
		this.getConfirmDhsStatus();
		this.getOrientationConfirmed();
		this.getApplicationApproved();
	},
	filters: {
		moment: function (date) {
			if (date === null) {
				return '';
			}
			return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
		},
	},
	methods: {
		computeUserCurrentStatus() {
			let isLocked = this.checkLockForComputeUserCurrentStatus();

			if (isLocked == false) {
				let data = [];
				if (this.user_type_id == 3 || (this.user_type_id == 4 && this.is_upgraded)) {
					data = this.mentorTasksSequence;
				} else {
					data = this.volunteerTasksSequence;
				}

				// assigning values to the list
				data.forEach((obj, index) => {
					data[index].value = this.approvalForm[obj.key];
				});

				for (let i = 0; i < data.length; i++) {
					const obj = data[i];
					if (obj.value == null || obj.value === '' || obj.value === 0 || obj.value === false || obj.value === 'In Progress') {
						this.approvalForm.user_current_status = obj.label;

						// get the current task id
						console.log('obj.key:', obj.key);
						let current_task_id = obj.key === 'completed' ? null : this.approvalForm['due_dates'][obj.key].task_id || null;
						console.log('current_task_id:', current_task_id);
						this.approvalForm.current_task_id = current_task_id != null ? current_task_id : '';
						break;
					}
				}
			}

			if (isLocked == true) {
				this.approvalForm.user_current_status = null;
				this.approvalForm.current_task_id = null;
			}
		},

		goToApprovals() {
			router.push({ name: 'approvals' });
		},

		getConfirmApplicationStatus() {
			var token = localStorage.getItem('token');
			var config = {
				headers: { Authorization: 'Bearer ' + token },
			};
			if (token) {
				axios.get('admin/approval/type?approval_type=confirm_application_status', config).then((res) => {
					this.confirmApplicationStatus = res.data.response;
				});
			}
		},

		getCharacterReferenceConfirmed() {
			var token = localStorage.getItem('token');
			var config = {
				headers: { Authorization: 'Bearer ' + token },
			};
			if (token) {
				axios.get('admin/approval/type?approval_type=character_reference_confirmed', config).then((res) => {
					this.characterReferenceConfirmed = res.data.response;
				});
			}
		},

		getConfirmPsvBackgroundStatus() {
			var token = localStorage.getItem('token');
			var config = {
				headers: { Authorization: 'Bearer ' + token },
			};
			if (token) {
				axios.get('admin/approval/type?approval_type=confirm_psv_background_status', config).then((res) => {
					this.confirmPsvBackgroundStatus = res.data.response;
					let changePSV = [];
					this.confirmPsvBackgroundStatus.forEach((status) => {
						changePSV.push({
							value: status,
							text: status.replace('PSV', 'Intellicorps'),
						});
					});
					this.confirmPsvBackgroundStatus = changePSV;
				});
			}
		},

		getConfirmDhsStatus() {
			var token = localStorage.getItem('token');
			var config = {
				headers: { Authorization: 'Bearer ' + token },
			};
			if (token) {
				axios.get('admin/approval/type?approval_type=confirm_dhs_status', config).then((res) => {
					this.confirmDhsStatus = res.data.response;
				});
			}
		},

		getOrientationConfirmed() {
			var token = localStorage.getItem('token');
			var config = {
				headers: { Authorization: 'Bearer ' + token },
			};
			if (token) {
				axios.get('admin/approval/type?approval_type=orienation_confirmed', config).then((res) => {
					this.orientationConfirmed = res.data.response;
				});
			}
		},

		getApplicationApproved() {
			var token = localStorage.getItem('token');
			var config = {
				headers: { Authorization: 'Bearer ' + token },
			};
			if (token) {
				axios.get('admin/approval/type?approval_type=application_approved', config).then((res) => {
					this.applicationApproved = res.data.response;
				});
			}
		},

		getApplicationCCM(location_id) {
			var token = localStorage.getItem('token');
			var config = {
				headers: { Authorization: 'Bearer ' + token },
			};
			if (token) {
				axios.get('admin/users/applicant/approver/7/' + location_id, config).then((res) => {
					this.applicationCCM = res.data.response;
				});
			}
		},

		getApplicationRCS(location_id) {
			var token = localStorage.getItem('token');
			var config = {
				headers: { Authorization: 'Bearer ' + token },
			};
			if (token) {
				axios.get('admin/users/applicant/approver/8/' + location_id, config).then((res) => {
					this.applicationRCS = res.data.response;
				});
			}
		},

		getApproval() {
			var token = localStorage.getItem('token');
			var config = {
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
				},
			};
			if (token) {
				axios
					.get('admin/user/approval/' + this.approvalId, config)
					.then((res) => {
						if (res.status == 200) {
							this.approvalForm = res.data.response;
							this.user_type_id = res.data.response.user_type_id;
							this.is_upgraded = res.data.response?.user?.is_upgraded;
							this.user_status = res.data.response.user_status;
							this.user_current_status = res.data.response.user_current_status;
							this.review_application = res.data.response.review_application;
							this.confirm_application_status = res.data.response.confirm_application_status;
							this.review_character_references = res.data.response.review_character_references;
							this.character_reference_confirmed = res.data.response.character_reference_confirmed;
							this.start_sterling_background_check = res.data.response.start_sterling_background_check;
							this.confirm_sterling_background_status = res.data.response.confirm_sterling_background_status;
							this.remove_ss_and_dL = res.data.response.remove_ss_and_dL;
							this.kickoff_dhs_background_check = res.data.response.kickoff_dhs_background_check;
							this.start_dhs_background_check = res.data.response.start_dhs_background_check;
							this.confirm_dhs_status = res.data.response.confirm_dhs_status;
							this.upload_letter_r_drive = res.data.response.upload_letter_r_drive;
							this.document_case_details = res.data.response.document_case_details;
							this.dhs_background_check_complete = res.data.response.dhs_background_check_complete;
							this.schedule_orientation_date = res.data.response.schedule_orientation_date;
							this.send_calendar_invite = res.data.response.send_calendar_invite;
							this.send_orientation_confirmation_email = res.data.response.send_orientation_confirmation_email;
							this.send_orientation_kickoff_email = res.data.response.send_orientation_kickoff_email;
							this.orienation_confirmed = res.data.response.orienation_confirmed;
							this.application_approved = res.data.response.application_approved;
							this.assign_applicant = res.data.response.assign_applicant;
							this.send_approval_email_confirmation = res.data.response.send_approval_email_confirmation;

							this.follow_up_character_reference = res.data.response.follow_up_character_reference;
							this.received_character_reference = res.data.response.received_character_reference;
							this.send_appilcation_received_email = res.data.response.send_appilcation_received_email;
							this.send_dhs_orientation_email = res.data.response.send_dhs_orientation_email;
							this.state_id_authorization = res.data.response.state_id_authorization;
							this.send_fingerprinting_instructions_email = res.data.response.send_fingerprinting_instructions_email;
							this.initiate_netstudy_for_fingerprinting = res.data.response.initiate_netstudy_for_fingerprinting;
							this.check_fingerprinting_status = res.data.response.check_fingerprinting_status;
							this.confirm_fingerprinting_with_applicant = res.data.response.confirm_fingerprinting_with_applicant;
							this.fingerprinting_completed = res.data.response.fingerprinting_completed;
							this.assigned_to_programs = res.data.response.assigned_to_programs;
							this.send_assignment_email_to_mentor_ccm = res.data.response.send_assignment_email_to_mentor_ccm;
							this.email_applicant_background_info_to_ccm = res.data.response.email_applicant_background_info_to_ccm;
							this.send_meeting_invite_applicant = res.data.response.send_meeting_invite_applicant;
							this.confirm_meeting_date = res.data.response.confirm_meeting_date;
							this.document_meeting_date = res.data.response.document_meeting_date;
							this.review_application_waitlist = res.data.response.review_application_waitlist;
							this.screening_meeting_complete = res.data.response.screening_meeting_complete;
							this.introduce_applicant_to_client = res.data.response.introduce_applicant_to_client;
							this.confirm__roi_release_info_signature = res.data.response.confirm__roi_release_info_signature;
							this.document_introduction_date_client = res.data.response.document_introduction_date_client;
							this.send_assignment_email = res.data.response.send_assignment_email;
							this.feedback_on_assignment = res.data.response.feedback_on_assignment;
							this.schedule_first_assignment = res.data.response.schedule_first_assignment;
							this.confirm_onboarding_complete = res.data.response.confirm_onboarding_complete;
							this.confirm_assignment_date_role = res.data.response.confirm_assignment_date_role;
							this.request_orientation = res.data.response.request_orientation;
							this.confirm_orientation = res.data.response.confirm_orientation;
							this.orientation = res.data.response.orientation;

							this.checkLock();

							this.getApplicationCCM(this.approvalForm.user.location_id);
							this.getApplicationRCS(this.approvalForm.user.location_id);

							this.computeUserCurrentStatus();
						}
					})
					.catch((err) => {
						if (err.response) {
							Swal.fire({
								title: 'Error!',
								text: err.response.data.error.message,
								icon: 'error',
								width: 350,
								showConfirmButton: true,
							});
							if (err.response.status == 401) {
								this.logout();
							}
						}
					});
			}
		},
		...authFackMethods,

		checkLock() {
			this.isLocked = false;

			if (this.user_type_id == 3 || (this.user_type_id == 4 && this.is_upgraded)) {
				// Mentor
				if (this.review_application != null) {
					if (this.confirm_application_status != null && !this.valid_application_statuses.includes(this.confirm_application_status)) {
						this.isLocked = true;
					} else {
						if (this.confirm_dhs_status != null && !this.valid_dhs_statuses.includes(this.confirm_dhs_status)) {
							this.isLocked = true;
						} else {
							if (this.confirm_sterling_background_status != null && !this.valid_sterling_background_statuses.includes(this.confirm_sterling_background_status)) {
								this.isLocked = true;
							}
						}
					}
				}
			} else {
				// Volunteer
				if (this.review_application != null) {
					if (this.confirm_application_status != null && !this.valid_application_statuses.includes(this.confirm_application_status)) {
						this.isLocked = true;
					} else {
						if (this.confirm_dhs_status != null && !this.valid_dhs_statuses.includes(this.confirm_dhs_status)) {
							this.isLocked = true;
						}
					}
				}
			}
		},

		checkLockForComputeUserCurrentStatus() {
			let isLocked = false;

			if (this.user_type_id == 3 || (this.user_type_id == 4 && this.is_upgraded)) {
				// Mentor
				if (this.approvalForm.review_application != null) {
					if (this.approvalForm.confirm_application_status != null && !this.valid_application_statuses.includes(this.approvalForm.confirm_application_status)) {
						isLocked = true;
					} else {
						if (this.approvalForm.confirm_dhs_status != null && !this.valid_dhs_statuses.includes(this.approvalForm.confirm_dhs_status)) {
							isLocked = true;
						} else {
							if (this.approvalForm.confirm_sterling_background_status != null && !this.valid_sterling_background_statuses.includes(this.approvalForm.confirm_sterling_background_status)) {
								isLocked = true;
							}
						}
					}
				}
			} else {
				// Volunteer
				if (this.approvalForm.review_application != null) {
					if (this.approvalForm.confirm_application_status != null && !this.valid_application_statuses.includes(this.approvalForm.confirm_application_status)) {
						isLocked = true;
					} else {
						if (this.approvalForm.confirm_dhs_status != null && !this.valid_dhs_statuses.includes(this.approvalForm.confirm_dhs_status)) {
							isLocked = true;
						}
					}
				}
			}

			return isLocked;
		},

		deleteApproval() {
			Swal.fire({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#34c38f',
				cancelButtonColor: '#f46a6a',
				confirmButtonText: 'Yes, delete it!',
			}).then((result) => {
				if (result.isConfirmed) {
					var token = localStorage.getItem('token');
					var config = {
						headers: {
							Authorization: 'Bearer ' + token,
							Accept: 'application/json',
						},
					};
					if (token) {
						axios
							.delete('admin/user/approval/' + this.approvalId, config)
							.then((res) => {
								if (res.status == '200') {
									Swal.fire({
										title: 'Deleted!',
										text: 'Approval has been deleted!',
										icon: 'success',
										width: 350,
										showConfirmButton: false,
										timer: 1500,
									});
									this.goToApprovals();
								}
							})
							.catch((err) => {
								if (err.response) {
									Swal.fire({
										title: 'Error!',
										text: err.response.data.error.message,
										icon: 'danger',
										width: 350,
										showConfirmButton: true,
									});
								}
							});
					}
				}
			});
		},

		addApproval() {
			var token = localStorage.getItem('token');
			var config = {
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
				},
			};
			if (token) {
				axios
					.post('admin/user/approval?id=' + this.approvalId, this.approvalForm, config)
					.then((res) => {
						if (res.status == '200') {
							Swal.fire({
								title: 'Successful!',
								text: 'Check added successfully!',
								icon: 'success',
								width: 350,
								showConfirmButton: false,
								timer: 1500,
							});
							this.typeSubmit = true;
							this.getApproval();
						}
					})
					.catch((err) => {
						if (err.response) {
							Swal.fire({
								title: 'Error!',
								text: err?.response?.data?.error?.message || err?.message || 'Something Went Wrong :(',
								icon: 'error',
								width: 350,
								showConfirmButton: true,
							});
						}
					});
			}
		},

		resumeApproval() {
			this.approvalForm.status = null;
			this.approvalForm.user_status = 'applicant';
			this.approvalForm.user.psv_check = 'applicant';
			if (!this.valid_application_statuses.includes(this.approvalForm.confirm_application_status)) {
				this.approvalForm.confirm_application_status = null;
			}
			if (!this.valid_dhs_statuses.includes(this.approvalForm.confirm_dhs_status)) {
				this.approvalForm.confirm_dhs_status = null;
			}
			if (!this.valid_sterling_background_statuses.includes(this.approvalForm.confirm_sterling_background_status)) {
				this.approvalForm.confirm_sterling_background_status = null;
			}
			this.computeUserCurrentStatus();
			this.addApproval();
			this.isLocked = false;
			this.$forceUpdate();
		},

		showCommentModal(type, assignedId) {
			this.getTags();
			this.$bvModal.show('commentModal');
			this.modalTitle = 'Add Comment';
			this.commentForm.type = type;
			this.commentForm.staff_id = assignedId;
			this.recordNotFound = false;
			this.commentForm.comment = '';
			this.commentForm.via = false;
		},
		getTags() {
			axios.get('admin/tags?pagination=true&per_page=1000').then((res) => {
				this.tags = res.data.response.data;
			});
		},

		showEmailModal(tag, type, assignedId) {
			this.emailForm.comment = '';
			this.emailForm.subject = '';
			this.emailForm.cc = '';
			this.emailForm.to = this.approvalForm.user.email;
			this.emailForm.type = tag;
			this.commentForm.staff_id = assignedId;
			this.recordNotFound = false;
			this.isLoading = true;

			if (tag == 'send_assignment_email' || tag == 'in_send_assignment_email') {
				if (this.assign_applicant === null) {
					alert('Please assign Volunteer Lead');
					return;
				}
				const rcs = this.applicationRCS.filter((item) => {
					return item.id == this.assign_applicant;
				});
				this.emailForm.to += ',' + rcs[0].email;
			}

			if (tag == 'send_assignment_email_to_mentor_ccm' || tag == 'in_send_assignment_email_to_mentor_ccm') {
				if (this.assign_applicant === null) {
					alert('Please assign CCM');
					return;
				}
				const ccm = this.applicationCCM.filter((item) => {
					return item.id == this.assign_applicant;
				});
				this.emailForm.to += ',' + ccm[0].email;
			}

			this.modalTitle = 'Send Email';
			this.$bvModal.show('emailModal');
			var token = localStorage.getItem('token');
			var config = {
				headers: { Authorization: 'Bearer ' + token },
			};
			if (token) {
				axios
					.get('admin/email_templates/by_tag?type=' + type + '&tag=' + tag, config)
					.then((res) => {
						if (res.status == '200') {
							this.isLoading = false;
							this.emailForm.comment = res.data.response.body;
							this.emailForm.subject = res.data.response.subject;
						}
					})
					.catch((err) => {
						if (err.response) {
							console.log(err.response);
						}
					});
			}
		},

		sendEmail() {
			var token = localStorage.getItem('token');
			var user = JSON.parse(localStorage.getItem('user'));
			var config = {
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
				},
			};
			this.isLoading = true;
			this.emailForm.user_id = this.user_id;
			this.emailForm.approval_id = this.approvalId;
			this.emailForm.staff_id = user.id;
			this.emailForm.rt = user.email;
			if (token) {
				axios
					.post('admin/user/approvals/email', this.emailForm, config)
					.then((res) => {
						this.isLoading = false;
						if (res.status == '200') {
							Swal.fire({
								title: 'Success!',
								text: 'Email sent successfully!',
								icon: 'success',
								width: 350,
								showConfirmButton: false,
								timer: 1500,
							});
							this.$bvModal.hide('emailModal');
							this.getApproval();
							this.emailForm = {
								user_id: this.user_id,
								staff_id: '',
								comment: '',
								cc: '',
								subject: '',
								type: '',
							};
						}
					})
					.catch((err) => {
						this.isLoading = false;
						if (err.response) {
							Swal.fire({
								title: 'Error!',
								text: err.response.data.error.message,
								icon: 'error',
								width: 350,
								showConfirmButton: true,
							});
						}
					});
			}
		},

		addComment() {
			this.typeSubmit = true;
			this.$v.$touch();
			if (!this.$v.commentForm.$invalid) {
				var token = localStorage.getItem('token');
				var user = JSON.parse(localStorage.getItem('user'));
				var config = {
					headers: {
						Authorization: 'Bearer ' + token,
						Accept: 'application/json',
					},
				};
				this.commentForm.user_id = this.user_id;
				this.commentForm.approval_id = this.approvalId;
				this.commentForm.staff_id = user.id;
				if (token) {
					axios
						.post('admin/user/approvals/comment', this.commentForm, config)
						.then((res) => {
							if (res.status == '200') {
								Swal.fire({
									title: 'Success!',
									text: 'Comment added successfully!',
									icon: 'success',
									width: 350,
									showConfirmButton: false,
									timer: 1500,
								});
								this.$bvModal.hide('commentModal');
								if (this.commentForm.via === true) {
									this.approvalForm.user_status = this.commentForm.user_current_status;
									if (this.commentForm.user_current_status != null) {
										this.approvalForm.user_current_status = this.commentForm.user_current_status;
									}
									if (this.commentForm.current_task_id != null) {
										this.approvalForm.current_task_id = this.commentForm.current_task_id;
									}
									this.approvalForm.introduce_applicant_to_client = true;
									this.addApproval();
								} else {
									this.getApproval();
								}
								this.commentForm = {
									user_id: this.user_id,
									tag_id: '',
									staff_id: '',
									comment: '',
									type: '',
									via: false,
								};
							}
						})
						.catch((err) => {
							if (err.response) {
								Swal.fire({
									title: 'Error!',
									text: err.response.data.error.message,
									icon: 'error',
									width: 350,
									showConfirmButton: true,
								});
							}
						});
				}
			}
		},

		updateApplicationStatus(status, value = null, user_current_status = null, tag = null, assigned_to = null, current_task_id = null) {
			if (status == 'Introduce Applicant to Client') {
				this.$bvModal.show('commentModal');
				this.modalTitle = 'Document Results of Screening Meeting';
				this.commentForm.type = tag;
				this.commentForm.staff_id = assigned_to;
				this.recordNotFound = false;
				this.commentForm.comment = '';
				this.commentForm.via = true;
				this.commentForm.status = status;
				this.commentForm.user_current_status = user_current_status;
				this.commentForm.current_task_id = current_task_id;

				this.approvalForm.introduce_applicant_to_client = false;
				return false;
			}
			this.approvalForm.user_status = status;
			if (value != null) {
				this.approvalForm.user_status += ' - ' + value;
			}
			if (user_current_status != null) {
				this.approvalForm.user_current_status = user_current_status;
			}
			if (current_task_id != null) {
				this.approvalForm.current_task_id = current_task_id;
			}
			this.computeUserCurrentStatus();
		},

		viewComment(type) {
			this.comments = [];
			this.recordNotFound = false;
			this.isLoading = true;
			this.modalTitle = 'View Comments';
			this.$bvModal.show('viewCommentModal');
			var token = localStorage.getItem('token');
			var config = {
				headers: { Authorization: 'Bearer ' + token },
			};
			if (token) {
				axios
					.get('admin/user/approvals/comment?type=' + type + '&user_id=' + this.user_id + '&approval_id=' + this.approvalId, config)
					.then((res) => {
						if (res.status == '200') {
							this.comments = res.data.response;
							this.isLoading = false;
							if (!this.comments.length) {
								this.recordNotFound = true;
							}
						}
					})
					.catch((err) => {
						if (err.response) {
							console.log(err.response);
						}
					});
			}
		},

		addDays(originalDate, days) {
			let cloneDate = new Date(originalDate.valueOf());
			cloneDate.setDate(cloneDate.getDate() + days);
			return cloneDate;
		},

		sendConfirmation() {
			var token = localStorage.getItem('token');
			var config = {
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
				},
			};
			if (token) {
				axios
					.get('admin/send/reference/email?user_id=' + this.user_id + '&user_type_id=' + this.user_type_id + '&approval_id=' + this.approvalId, config)
					.then((res) => {
						if (res.status == 200) {
							Swal.fire({
								title: 'Good job!',
								text: 'Reference submitted successfully!',
								icon: 'success',
								width: 350,
								showConfirmButton: false,
								timer: 1500,
							});
						}
					})
					.catch((err) => {
						if (err.response) {
							console.log(err.response.data.error.message);
						}
					});
			}
		},

		getFullName(user) {
			let fullname = '';
			if (user.first_name && user.first_name.length) {
				fullname += user.first_name;
			}
			if (user.last_name && user.last_name.length) {
				fullname += ' ' + user.last_name;
			}
			return fullname;
		},
	},
};
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="card">
			<div class="card-body">
				<div class="d-flex">
					<div class="me-2">
						<h5 class="card-title mb-3">
							<router-link v-if="approvalForm && approvalForm.user" tag="a" :to="`/registration-progress/user/${approvalForm.user.id}`">
								<span>
									{{ getFullName(approvalForm.user) }}
								</span>
								- Profile
							</router-link>

							<span v-else> XXX - Profile </span>
						</h5>
					</div>
				</div>
				<form v-if="approvalForm">
					<!-- MENTOR -->
					<div v-if="user_type_id == 3 || (user_type_id == 4 && is_upgraded)">
						<div class="application-review">
							<h5 class="font-size-16 mt-4 d-inline-block text-decoration-underline">Application Review</h5>
							<div class="float-end">
								<button type="button" @click="resumeApproval" class="btn btn-primary me-2" v-if="validResumeApprovalUserTypes.includes(currentUserData['user_type_id']) && this.isLocked == true">Resume Approval</button>
								<button type="button" @click="deleteApproval" class="btn btn-danger me-2">Delete</button>
								<button type="button" @click="addApproval" class="btn btn-primary">Update</button>
								<div class="btn-fixed">
									<button type="button" @click="addApproval" class="btn btn-primary">Update</button>
								</div>
							</div>
							<div class="table-responsive">
								<table class="table table-sm align-middle table-nowrap mb-0">
									<thead class="table-light">
										<tr>
											<th scope="col">Name</th>
											<th scope="col">Assigned to</th>
											<th scope="col">Due Date</th>
											<th scope="col">Status</th>
											<th scope="col">Actions</th>
										</tr>
									</thead>
									<tbody>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Review Application</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.review_application.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1" v-if="approvalForm.created_at">{{ approvalForm.due_dates.review_application.due_date | moment }}</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.review_application" class="form-check-input" @change="updateApplicationStatus('Review Application', null, 'Confirm Application Status', null, null, approvalForm.due_dates.confirm_application_status.task_id)" type="checkbox" />
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('review_application', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>
												<b-button class="ms-2 py-0 px-1" @click="viewComment('review_application')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.review_application > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.review_application }} </span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Confirm Application Status</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.confirm_application_status.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.confirm_application_status.due_date | moment }}</p>
											</td>
											<td>
												<b-form-select class="form-select w-75" @change="updateApplicationStatus('Confirm Application Status', approvalForm.confirm_application_status, 'Start Intellicorps Background Check', null, null, approvalForm.due_dates.start_sterling_background_check.task_id)" v-model="approvalForm.confirm_application_status" :options="confirmApplicationStatus">
													<option slot="first" :value="null">Select Status</option>
												</b-form-select>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('confirm_application_status', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('confirm_application_status')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.confirm_application_status > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.confirm_application_status }} </span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Start Intellicorps Background Check</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.start_sterling_background_check.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.start_sterling_background_check.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.start_sterling_background_check" class="form-check-input" @change="updateApplicationStatus('Start Intellicorps Background Check', null, 'Send Application Received Email', null, null, approvalForm.due_dates.send_appilcation_received_email.task_id)" type="checkbox" />
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('start_sterling_background_check', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('start_sterling_background_check')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.start_sterling_background_check > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.start_sterling_background_check }} </span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Send Application Received Email</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.send_appilcation_received_email.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.send_appilcation_received_email.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.send_appilcation_received_email" class="form-check-input" @change="updateApplicationStatus('Send Application Received Email', null, 'Confirm Intellicorps Background Status', null, null, approvalForm.due_dates.confirm_sterling_background_status.task_id)" type="checkbox" />
													<div class="text-center">
														<b-button class="py-0 px-1" @click="showEmailModal('send_appilcation_received_email', 'mentor', approvalForm.assigned_to.id)" variant="primary" title="Send Email">
															<i class="bx bx-envelope font-size-20 mt-1"></i>
														</b-button>
													</div>
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('send_appilcation_received_email', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('send_appilcation_received_email')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.send_appilcation_received_email > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.send_appilcation_received_email }} </span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Confirm Intellicorps Background Status</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.confirm_sterling_background_status.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.confirm_sterling_background_status.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<b-form-select class="form-select w-75" @change="updateApplicationStatus('Confirm Intellicorps Background Status', approvalForm.confirm_sterling_background_status, 'Remove SS and DL', null, null, approvalForm.due_dates.remove_ss_and_dL.task_id)" v-model="approvalForm.confirm_sterling_background_status" :options="confirmPsvBackgroundStatus">
													<option slot="first" :value="null">Select Status</option>
												</b-form-select>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('confirm_sterling_background_status', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('confirm_sterling_background_status')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.confirm_sterling_background_status > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.confirm_sterling_background_status }} </span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Remove SS and DL</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.remove_ss_and_dL.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.remove_ss_and_dL.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.remove_ss_and_dL" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Remove SS and DL', null, 'Follow Up with Character Reference', null, null, approvalForm.due_dates.review_character_references.task_id)" />
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('remove_ss_and_dL', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('remove_ss_and_dL')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.remove_ss_and_dL > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.remove_ss_and_dL }} </span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Review Character References</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.review_character_references.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.review_character_references.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.review_character_references" @change="updateApplicationStatus('Review Character References', null, 'Character Reference Confirmed', null, null, approvalForm.due_dates.character_reference_confirmed.task_id)" class="form-check-input" type="checkbox" />
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('review_character_references', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('review_character_references')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.review_character_references > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.review_character_references }} </span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Character Reference Confirmed</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.character_reference_confirmed.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.character_reference_confirmed.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<b-form-select class="form-select w-75" @change="updateApplicationStatus('Character Reference Confirmed', approvalForm.character_reference_confirmed, 'Screening Meeting Complete', null, null, approvalForm.due_dates.screening_meeting_complete.task_id)" v-model="approvalForm.character_reference_confirmed" :options="characterReferenceConfirmed">
													<option slot="first" :value="null">Select Status</option>
												</b-form-select>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('character_reference_confirmed', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('character_reference_confirmed')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.character_reference_confirmed > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.character_reference_confirmed }} </span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Screening Meeting Complete</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.screening_meeting_complete.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.screening_meeting_complete.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.screening_meeting_complete" @change="updateApplicationStatus('Screening Meeting Complete', null, 'Send DHS email', null, null, approvalForm.due_dates.send_dhs_orientation_email.task_id)" class="form-check-input" type="checkbox" />
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('screening_meeting_complete', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('screening_meeting_complete')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.screening_meeting_complete > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.screening_meeting_complete }} </span>
												</b-button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<div class="background-check">
							<h5 class="font-size-16 mt-4 text-decoration-underline">Background Check</h5>
							<div class="table-responsive">
								<table class="table table-sm align-middle table-nowrap mb-0">
									<thead class="table-light">
										<tr>
											<th scope="col">Name</th>
											<th scope="col">Assigned to</th>
											<th scope="col">Due Date</th>
											<th scope="col">Status</th>
											<th scope="col">Actions</th>
										</tr>
									</thead>
									<tbody>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Send DHS email</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.send_dhs_orientation_email.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.send_dhs_orientation_email.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.send_dhs_orientation_email" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Send DHS email', null, 'State ID, Authorization Form, Date of Orientation Received', null, null, approvalForm.due_dates.state_id_authorization.task_id)" />
													<div class="text-center">
														<b-button class="py-0 px-1" @click="showEmailModal('send_dhs_orientation_email', 'mentor', approvalForm.assigned_to.id)" variant="primary" title="Send Email">
															<i class="bx bx-envelope font-size-20 mt-1"></i>
														</b-button>
													</div>
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('send_dhs_orientation_email', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('send_dhs_orientation_email')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.send_dhs_orientation_email > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.send_dhs_orientation_email }} </span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">State ID, Authorization Form, Date of Orientation Received</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.state_id_authorization.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.state_id_authorization.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.state_id_authorization" class="form-check-input" type="checkbox" @change="updateApplicationStatus('State ID, Authorization Form, Date of Orientation Received', null, 'Send Fingerprinting instructions email', null, null, approvalForm.due_dates.send_fingerprinting_instructions_email.task_id)" />
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('state_id_authorization', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('state_id_authorization')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.state_id_authorization > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.state_id_authorization }} </span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Send Fingerprinting instructions email</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.send_fingerprinting_instructions_email.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.send_fingerprinting_instructions_email.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.send_fingerprinting_instructions_email" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Send Fingerprinting instructions email', null, 'Start DHS Background Check', null, null, approvalForm.due_dates.start_dhs_background_check.task_id)" />
													<div class="text-center">
														<b-button class="py-0 px-1" @click="showEmailModal('send_fingerprinting_instructions_email', 'mentor', approvalForm.assigned_to.id)" variant="primary" title="Send Email">
															<i class="bx bx-envelope font-size-20 mt-1"></i>
														</b-button>
													</div>
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('send_fingerprinting_instructions_email', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('send_fingerprinting_instructions_email')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.send_fingerprinting_instructions_email > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.send_fingerprinting_instructions_email }} </span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Start DHS Background Check</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.start_dhs_background_check.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.start_dhs_background_check.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="d-flex align-items-center justify-content-between">
													<div class="form-check mb-2">
														<input v-model="approvalForm.start_dhs_background_check" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Start DHS Background Check', null, 'Check Fingerprinting Status', null, null, approvalForm.due_dates.check_fingerprinting_status.task_id)" />
													</div>
													<div class="d-flex align-items-center justify-content-between">
														<div>
															<small>Submission date</small>
															<input type="date" v-model="approvalForm.due_dates.start_dhs_background_check.submission_date" class="form-control" />
														</div>
														<div>
															<small>Target date</small>
															<input type="date" v-model="approvalForm.due_dates.start_dhs_background_check.target_date" class="form-control" />
														</div>
													</div>
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('start_dhs_background_check', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('start_dhs_background_check')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.start_dhs_background_check > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.start_dhs_background_check }} </span>
												</b-button>
											</td>
										</tr>

										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Check Fingerprinting Status</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.check_fingerprinting_status.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.check_fingerprinting_status.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.check_fingerprinting_status" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Check Fingerprinting Status', null, 'Confirm Fingerprinting with Applicant', null, null, approvalForm.due_dates.confirm_fingerprinting_with_applicant.task_id)" />
													<div class="text-center">
														<b-button class="py-0 px-1" @click="showEmailModal('follow_up_on_check_fingerprinting_status', 'mentor', approvalForm.assigned_to.id)" variant="primary" title="Send Email">
															<i class="bx bx-envelope font-size-20 mt-1"></i>
														</b-button>
													</div>
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('check_fingerprinting_status', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('check_fingerprinting_status')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.check_fingerprinting_status > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.check_fingerprinting_status }} </span>
												</b-button>
											</td>
										</tr>

										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Confirm Fingerprinting with Applicant</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.confirm_fingerprinting_with_applicant.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.confirm_fingerprinting_with_applicant.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.confirm_fingerprinting_with_applicant" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Confirm Fingerprinting with Applicant', null, 'Follow-up on Check Fingerprinting Status', null, null, approvalForm.due_dates.follow_up_on_check_fingerprinting_status.task_id)" />
													<div class="text-center">
														<b-button class="py-0 px-1" @click="showEmailModal('confirm_fingerprinting_with_applicant', 'mentor', approvalForm.assigned_to.id)" variant="primary" title="Send Email">
															<i class="bx bx-envelope font-size-20 mt-1"></i>
														</b-button>
													</div>
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('confirm_fingerprinting_with_applicant', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('confirm_fingerprinting_with_applicant')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.confirm_fingerprinting_with_applicant > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.confirm_fingerprinting_with_applicant }} </span>
												</b-button>
											</td>
										</tr>

										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Follow-up on Check Fingerprinting Status</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.follow_up_on_check_fingerprinting_status.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.follow_up_on_check_fingerprinting_status.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.follow_up_on_check_fingerprinting_status" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Follow-up on Check Fingerprinting Status', null, 'Confirm DHS Status', null, null, approvalForm.due_dates.confirm_dhs_status.task_id)" />
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('follow_up_on_check_fingerprinting_status', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('follow_up_on_check_fingerprinting_status')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.follow_up_on_check_fingerprinting_status > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.follow_up_on_check_fingerprinting_status }} </span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Confirm DHS Status</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.confirm_dhs_status.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.confirm_dhs_status.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<b-form-select class="form-select w-75" @change="updateApplicationStatus('Confirm DHS Status', approvalForm.confirm_dhs_status, 'Upload DHS determination letter to R Drive', null, null, approvalForm.due_dates.upload_letter_r_drive.task_id)" v-model="approvalForm.confirm_dhs_status" :options="confirmDhsStatus">
													<option slot="first" :value="null">Select Status</option>
												</b-form-select>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('confirm_dhs_status', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('confirm_dhs_status')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.confirm_dhs_status > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.confirm_dhs_status }} </span>
												</b-button>
											</td>
										</tr>

										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Upload DHS determination letter to R Drive</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.upload_letter_r_drive.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.upload_letter_r_drive.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.upload_letter_r_drive" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Upload DHS determination letter to R Drive', null, 'Document Case Details', null, null, approvalForm.due_dates.document_case_details.task_id)" />
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('upload_letter_r_drive', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('upload_letter_r_drive')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.upload_letter_r_drive > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.upload_letter_r_drive }} </span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Document Case Details</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.document_case_details.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.document_case_details.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.document_case_details" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Document Case Details', null, 'Application Approved', null, null, approvalForm.due_dates.application_approved.task_id)" />
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('document_case_details', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('document_case_details')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.document_case_details > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.document_case_details }} </span>
												</b-button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<div class="confirmation">
							<h5 class="font-size-16 mt-4 text-decoration-underline">Confirmation</h5>
							<div class="table-responsive">
								<table class="table table-sm align-middle table-nowrap mb-0">
									<thead class="table-light">
										<tr>
											<th scope="col">Name</th>
											<th scope="col">Assigned to</th>
											<th scope="col">Due Date</th>
											<th scope="col">Status</th>
											<th scope="col">Actions</th>
										</tr>
									</thead>
									<tbody>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Application Approved</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.application_approved.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.application_approved.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<b-form-select class="form-select w-75" @change="updateApplicationStatus('Application Approved', approvalForm.application_approved, 'Assign Applicant', null, null, approvalForm.due_dates.assign_applicant.task_id)" v-model="approvalForm.application_approved" :options="applicationApproved">
													<option slot="first" :value="null">Select Status</option>
												</b-form-select>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('application_approved', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>
												<b-button class="ms-2 py-0 px-1" @click="viewComment('application_approved')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.application_approved > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.application_approved }} </span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Assign Applicant</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.assign_applicant.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.assign_applicant.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<b-form-select class="form-select w-75" @change="updateApplicationStatus('Assign Applicant', approvalForm.assign_applicant, 'Send Calendar Invite', null, null, approvalForm.due_dates.send_calendar_invite.task_id)" v-model="approvalForm.assign_applicant">
													<option v-for="user in applicationCCM" :key="user.id" :value="user.id">{{ getFullName(user) }}</option>
													<option slot="first" :value="null">Select CCM</option>
												</b-form-select>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('assign_applicant', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('assign_applicant')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.assign_applicant > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.assign_applicant }} </span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<!-- Send Calendar Invite -->
												<h5 class="font-size-13 text-truncate mb-1">Schedule Orientation / Intro Meeting</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.send_calendar_invite.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.send_calendar_invite.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.send_calendar_invite" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Send Calendar Invite', null, 'Review Application / Waitlist', null, null, approvalForm.due_dates.review_application_waitlist.task_id)" />
													<div class="text-center">
														<b-button class="py-0 px-1" @click="showEmailModal('request_intro_meeting', 'mentor', approvalForm.assigned_to.id)" variant="primary" title="Send Email">
															<i class="bx bx-envelope font-size-20 mt-1"></i>
														</b-button>
													</div>
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('send_calendar_invite', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('send_calendar_invite')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.send_calendar_invite > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.send_calendar_invite }} </span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Review Application / Waitlist</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.review_application_waitlist.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.review_application_waitlist.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.review_application_waitlist" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Review Application / Waitlist', null, 'Orientation / Intro Meeting Complete', null, null, approvalForm.due_dates.orientation_intro_meeting_complete.task_id)" />
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('review_application_waitlist', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('review_application_waitlist')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.review_application_waitlist > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.review_application_waitlist }} </span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Orientation / Intro Meeting Complete</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.orientation.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.orientation.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.orientation" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Orientation / Intro Meeting Complete', null, 'Confirm (ROI) Release of Information Signature', null, null, approvalForm.due_dates.confirm__roi_release_info_signature.task_id)" />
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('orientation', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('orientation')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.orientation > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.orientation }} </span>
												</b-button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<div class="assignment">
							<h5 class="font-size-16 mt-4 text-decoration-underline">Assignment</h5>
							<div class="table-responsive">
								<table class="table table-sm align-middle table-nowrap mb-0">
									<thead class="table-light">
										<tr>
											<th scope="col">Name</th>
											<th scope="col">Assigned to</th>
											<th scope="col">Due Date</th>
											<th scope="col">Status</th>
											<th scope="col">Actions</th>
										</tr>
									</thead>
									<tbody>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Confirm (ROI) Release of Information Signature</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.confirm__roi_release_info_signature.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.confirm__roi_release_info_signature.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.confirm__roi_release_info_signature" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Confirm (ROI) Release of Information Signature', null, 'Document Introduction Date/Client', null, null, approvalForm.due_dates.document_introduction_date_client.task_id)" />
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('confirm__roi_release_info_signature', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('confirm__roi_release_info_signature')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.confirm__roi_release_info_signature > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.confirm__roi_release_info_signature }} </span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Document Introduction Date/Client</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">{{ approvalForm.due_dates.document_introduction_date_client.assignee }}</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.document_introduction_date_client.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.document_introduction_date_client" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Document Introduction Date/Client', null, 'Completed', null, null, null)" />
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('document_introduction_date_client', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('document_introduction_date_client')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.document_introduction_date_client > 0" class="mntc_approvals_comment_count"> {{ approvalForm.comments.document_introduction_date_client }} </span>
												</b-button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>

					<!-- VOLUNTEER -->
					<div v-else-if="user_type_id == 4">
						<div class="application-review">
							<div>
								<h5 class="font-size-16 mt-4 d-inline-block text-decoration-underline">Application Review</h5>
								<div class="float-end">
									<button type="button" @click="resumeApproval" class="btn btn-primary me-2" v-if="validResumeApprovalUserTypes.includes(currentUserData['user_type_id']) && this.isLocked == true">Resume Approval</button>
									<button type="button" @click="deleteApproval" class="btn btn-danger me-2">Delete</button>
									<button type="button" @click="addApproval" class="btn btn-primary">Update</button>
									<div class="btn-fixed">
										<button type="button" @click="addApproval" class="btn btn-primary">Update</button>
									</div>
								</div>
							</div>

							<div class="table-responsive">
								<table class="table table-sm align-middle table-nowrap mb-0">
									<thead class="table-light">
										<tr>
											<th scope="col">Name</th>
											<th scope="col">Assigned to</th>
											<th scope="col">Due Date</th>
											<th scope="col">Status</th>
											<th scope="col">Actions</th>
										</tr>
									</thead>
									<tbody>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Review Application</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													{{ approvalForm.due_dates.review_application.assignee }}
												</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1" v-if="approvalForm.created_at">
													{{ approvalForm.due_dates.review_application.due_date | moment }}
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.review_application" class="form-check-input" @change="updateApplicationStatus('Review Application', null, 'Confirm Application Status', null, null, approvalForm.due_dates.confirm_application_status.task_id)" type="checkbox" />
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('review_application', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>
												<b-button class="ms-2 py-0 px-1" @click="viewComment('review_application')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>

													<span v-if="approvalForm.comments.review_application > 0" class="mntc_approvals_comment_count">
														{{ approvalForm.comments.review_application }}
													</span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Confirm Application Status</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													{{ approvalForm.due_dates.confirm_application_status.assignee }}
												</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													{{ approvalForm.due_dates.confirm_application_status.due_date | moment }}
												</p>
											</td>
											<td>
												<b-form-select class="form-select w-75" @change="updateApplicationStatus('Confirm Application Status', approvalForm.confirm_application_status, 'Screening Meeting (Phone Call)', null, null, approvalForm.due_dates.request_intro_meeting.task_id)" v-model="approvalForm.confirm_application_status" :options="confirmApplicationStatus">
													<option slot="first" :value="null">Select Status</option>
												</b-form-select>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('confirm_application_status', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('confirm_application_status')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.confirm_application_status > 0" class="mntc_approvals_comment_count">
														{{ approvalForm.comments.confirm_application_status }}
													</span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Screening Meeting (Phone Call)</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													{{ approvalForm.due_dates.request_intro_meeting.assignee }}
												</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.request_intro_meeting.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.request_intro_meeting" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Screening Meeting (Phone Call)', null, 'Send Application Response and DHS email', null, null, approvalForm.due_dates.send_application_response_and_dhs_email.task_id)" />
													<div class="text-center">
														<b-button class="py-0 px-1" @click="showEmailModal('request_intro_meeting', 'volunteer', approvalForm.assigned_to.id)" variant="primary" title="Send Email">
															<i class="bx bx-envelope font-size-20 mt-1"></i>
														</b-button>
													</div>
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('request_intro_meeting', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('request_intro_meeting')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.request_intro_meeting > 0" class="mntc_approvals_comment_count">
														{{ approvalForm.comments.request_intro_meeting }}
													</span>
												</b-button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<div class="background-check">
							<h5 class="font-size-16 mt-4 text-decoration-underline">Background Check</h5>
							<div class="table-responsive">
								<table class="table table-sm align-middle table-nowrap mb-0">
									<thead class="table-light">
										<tr>
											<th scope="col">Name</th>
											<th scope="col">Assigned to</th>
											<th scope="col">Due Date</th>
											<th scope="col">Status</th>
											<th scope="col">Actions</th>
										</tr>
									</thead>
									<tbody>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Send Application Response and DHS email</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													{{ approvalForm.due_dates.send_dhs_orientation_email.assignee }}
												</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.send_dhs_orientation_email.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.send_dhs_orientation_email" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Send Application Response and DHS email', null, 'State ID, Authorization Form, Date of Orientation Received', null, null, approvalForm.due_dates.state_id_authorization.task_id)" />
													<div class="text-center">
														<b-button class="py-0 px-1" @click="showEmailModal('send_dhs_orientation_email', 'volunteer', approvalForm.assigned_to.id)" variant="primary" title="Send Email">
															<i class="bx bx-envelope font-size-20 mt-1"></i>
														</b-button>
													</div>
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('send_dhs_orientation_email', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('send_dhs_orientation_email')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.send_dhs_orientation_email > 0" class="mntc_approvals_comment_count">
														{{ approvalForm.comments.send_dhs_orientation_email }}
													</span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">State ID, Authorization Form, Date of Orientation Received</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													{{ approvalForm.due_dates.state_id_authorization.assignee }}
												</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.state_id_authorization.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.state_id_authorization" class="form-check-input" type="checkbox" @change="updateApplicationStatus('State ID, Authorization Form, Date of Orientation Received', null, 'Send Fingerprinting instructions email', null, null, approvalForm.due_dates.send_fingerprinting_instructions_email.task_id)" />
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('state_id_authorization', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('state_id_authorization')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.state_id_authorization > 0" class="mntc_approvals_comment_count">
														{{ approvalForm.comments.state_id_authorization }}
													</span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Send Fingerprinting instructions email</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													{{ approvalForm.due_dates.send_fingerprinting_instructions_email.assignee }}
												</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.send_fingerprinting_instructions_email.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.send_fingerprinting_instructions_email" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Send Fingerprinting instructions email', null, 'Start DHS Background Check', null, null, approvalForm.due_dates.start_dhs_background_check.task_id)" />
													<div class="text-center">
														<b-button class="py-0 px-1" @click="showEmailModal('send_fingerprinting_instructions_email', 'volunteer', approvalForm.assigned_to.id)" variant="primary" title="Send Email">
															<i class="bx bx-envelope font-size-20 mt-1"></i>
														</b-button>
													</div>
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('send_fingerprinting_instructions_email', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('send_fingerprinting_instructions_email')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.send_fingerprinting_instructions_email > 0" class="mntc_approvals_comment_count">
														{{ approvalForm.comments.send_fingerprinting_instructions_email }}
													</span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Start DHS Background Check</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													{{ approvalForm.due_dates.start_dhs_background_check.assignee }}
												</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.start_dhs_background_check.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="d-flex align-items-center justify-content-between">
													<div class="form-check mb-2">
														<input v-model="approvalForm.start_dhs_background_check" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Start DHS Background Check', null, 'Check Fingerprinting Status', null, null, approvalForm.due_dates.check_fingerprinting_status.task_id)" />
													</div>
													<div class="d-flex align-items-center justify-content-between">
														<div>
															<small>Submission date</small>
															<input type="date" v-model="approvalForm.due_dates.start_dhs_background_check.submission_date" class="form-control" />
														</div>
														<div>
															<small>Target date</small>
															<input type="date" v-model="approvalForm.due_dates.start_dhs_background_check.target_date" class="form-control" />
														</div>
													</div>
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('start_dhs_background_check', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('start_dhs_background_check')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.start_dhs_background_check > 0" class="mntc_approvals_comment_count">
														{{ approvalForm.comments.start_dhs_background_check }}
													</span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Check Fingerprinting Status</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													{{ approvalForm.due_dates.check_fingerprinting_status.assignee }}
												</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.check_fingerprinting_status.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.check_fingerprinting_status" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Check Fingerprinting Status', null, 'Confirm Fingerprinting with Applicant', null, null, approvalForm.due_dates.confirm_fingerprinting_with_applicant.task_id)" />
													<div class="text-center">
														<b-button class="py-0 px-1" @click="showEmailModal('follow_up_on_check_fingerprinting_status', 'mentor', approvalForm.assigned_to.id)" variant="primary" title="Send Email">
															<i class="bx bx-envelope font-size-20 mt-1"></i>
														</b-button>
													</div>
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('check_fingerprinting_status', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('check_fingerprinting_status')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.check_fingerprinting_status > 0" class="mntc_approvals_comment_count">
														{{ approvalForm.comments.check_fingerprinting_status }}
													</span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Confirm Fingerprinting with Applicant</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													{{ approvalForm.due_dates.confirm_fingerprinting_with_applicant.assignee }}
												</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.confirm_fingerprinting_with_applicant.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.confirm_fingerprinting_with_applicant" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Confirm Fingerprinting with Applicant', null, 'Follow-up on Check Fingerprinting Status', null, null, approvalForm.due_dates.follow_up_on_check_fingerprinting_status.task_id)" />
													<div class="text-center">
														<b-button class="py-0 px-1" @click="showEmailModal('confirm_fingerprinting_with_applicant', 'volunteer', approvalForm.assigned_to.id)" variant="primary" title="Send Email">
															<i class="bx bx-envelope font-size-20 mt-1"></i>
														</b-button>
													</div>
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('confirm_fingerprinting_with_applicant', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('confirm_fingerprinting_with_applicant')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.confirm_fingerprinting_with_applicant > 0" class="mntc_approvals_comment_count">
														{{ approvalForm.comments.confirm_fingerprinting_with_applicant }}
													</span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Follow-up on Check Fingerprinting Status</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													{{ approvalForm.due_dates.follow_up_on_check_fingerprinting_status.assignee }}
												</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.follow_up_on_check_fingerprinting_status.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.follow_up_on_check_fingerprinting_status" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Follow-up on Check Fingerprinting Status', null, 'Confirm DHS Status', null, null, approvalForm.due_dates.confirm_dhs_status.task_id)" />
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('follow_up_on_check_fingerprinting_status', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('follow_up_on_check_fingerprinting_status')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.follow_up_on_check_fingerprinting_status > 0" class="mntc_approvals_comment_count">
														{{ approvalForm.comments.follow_up_on_check_fingerprinting_status }}
													</span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Confirm DHS Status</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													{{ approvalForm.due_dates.confirm_dhs_status.assignee }}
												</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.confirm_dhs_status.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<b-form-select class="form-select w-75" @change="updateApplicationStatus('Confirm DHS Status', approvalForm.confirm_dhs_status, 'Upload DHS determination letter to R Drive', null, null, approvalForm.due_dates.upload_letter_r_drive.task_id)" v-model="approvalForm.confirm_dhs_status" :options="confirmDhsStatus">
													<option slot="first" :value="null">Select Status</option>
												</b-form-select>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('confirm_dhs_status', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('confirm_dhs_status')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.confirm_dhs_status > 0" class="mntc_approvals_comment_count">
														{{ approvalForm.comments.confirm_dhs_status }}
													</span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Upload DHS determination letter to R Drive</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													{{ approvalForm.due_dates.upload_letter_r_drive.assignee }}
												</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.upload_letter_r_drive.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.upload_letter_r_drive" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Upload DHS determination letter to R Drive', null, 'Document Case Details', null, null, approvalForm.due_dates.document_case_details.task_id)" />
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('upload_letter_r_drive', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('upload_letter_r_drive')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.upload_letter_r_drive > 0" class="mntc_approvals_comment_count">
														{{ approvalForm.comments.upload_letter_r_drive }}
													</span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Document Case Details</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													{{ approvalForm.due_dates.document_case_details.assignee }}
												</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.document_case_details.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.document_case_details" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Document Case Details', null, 'Orientation / Intro Meeting Complete', null, null, approvalForm.due_dates.orientation.task_id)" />
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('document_case_details', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('document_case_details')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.document_case_details > 0" class="mntc_approvals_comment_count">
														{{ approvalForm.comments.document_case_details }}
													</span>
												</b-button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<div class="orientation">
							<h5 class="font-size-16 mt-4 text-decoration-underline">Orientation</h5>
							<div class="table-responsive">
								<table class="table table-sm align-middle table-nowrap mb-0">
									<thead class="table-light">
										<tr>
											<th scope="col">Name</th>
											<th scope="col">Assigned to</th>
											<th scope="col">Due Date</th>
											<th scope="col">Status</th>
											<th scope="col">Actions</th>
										</tr>
									</thead>
									<tbody>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Orientation / Intro Meeting Complete</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													{{ approvalForm.due_dates.orientation.assignee }}
												</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.orientation.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<b-form-select class="form-select w-75" @change="updateApplicationStatus('Orientation / Intro Meeting Complete', approvalForm.orientation, 'Confirm Assignment Date/Role', null, null, approvalForm.due_dates.confirm_assignment_date_role.task_id)" v-model="approvalForm.orientation">
													<option v-for="user in applicationRCS" :key="user.id" :value="user.id">
														{{ getFullName(user) }}
													</option>
													<option slot="first" :value="null">Select Volunteer Lead</option>
												</b-form-select>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('orientation', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('orientation')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.orientation > 0" class="mntc_approvals_comment_count">
														{{ approvalForm.comments.orientation }}
													</span>
												</b-button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<div class="assignment">
							<h5 class="font-size-16 mt-4 text-decoration-underline">Assignment</h5>
							<div class="table-responsive">
								<table class="table table-sm align-middle table-nowrap mb-0">
									<thead class="table-light">
										<tr>
											<th scope="col">Name</th>
											<th scope="col">Assigned to</th>
											<th scope="col">Due Date</th>
											<th scope="col">Status</th>
											<th scope="col">Actions</th>
										</tr>
									</thead>
									<tbody>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Confirm Assignment Date/Role</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													{{ approvalForm.due_dates.confirm_assignment_date_role.assignee }}
												</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.confirm_assignment_date_role.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.confirm_assignment_date_role" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Confirm Assignment Date/Role', null, 'Schedule first Assignment', null, null, approvalForm.due_dates.schedule_first_assignment.task_id)" />
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('confirm_assignment_date_role', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('confirm_assignment_date_role')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.confirm_assignment_date_role > 0" class="mntc_approvals_comment_count">
														{{ approvalForm.comments.confirm_assignment_date_role }}
													</span>
												</b-button>
											</td>
										</tr>
										<tr :class="isLocked === false ? '' : 'tr-disable'">
											<td>
												<h5 class="font-size-13 text-truncate mb-1">Schedule first Assignment</h5>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													{{ approvalForm.due_dates.schedule_first_assignment.assignee }}
												</p>
											</td>
											<td>
												<p class="font-size-13 text-truncate mb-1">
													<input type="date" v-model="approvalForm.due_dates.schedule_first_assignment.due_date" class="form-control" />
												</p>
											</td>
											<td>
												<div class="form-check mb-2">
													<input v-model="approvalForm.schedule_first_assignment" class="form-check-input" type="checkbox" @change="updateApplicationStatus('Schedule first Assignment', null, 'Completed', null, null, null)" />
												</div>
											</td>
											<td>
												<b-button class="py-0 px-1" @click="showCommentModal('schedule_first_assignment', approvalForm.assigned_to.id)" variant="primary" title="Add Comment">
													<i class="bx bx-plus font-size-20 mt-1"></i>
												</b-button>

												<b-button class="ms-2 py-0 px-1" @click="viewComment('schedule_first_assignment')" variant="primary" title="View">
													<i class="bx bx-show font-size-20 mt-1"></i>
													<span v-if="approvalForm.comments.schedule_first_assignment > 0" class="mntc_approvals_comment_count">
														{{ approvalForm.comments.schedule_first_assignment }}
													</span>
												</b-button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>

		<b-modal id="commentModal" centered :title="modalTitle" title-class="font-18" hide-footer>
			<form>
				<div class="mb-3">
					<label>Comment</label>
					<textarea v-model="commentForm.comment" class="form-control" name="comment" rows="5" placeholder="Add Comment"></textarea>
				</div>
				<div class="mb-3">
					<label class="mt-0">Select Tag</label>
					<b-form-select class="form-select" v-model="commentForm.tag_id" :options="tags" value-field="id" text-field="name">
						<option slot="first" :value="null">Select Tag</option>
					</b-form-select>
				</div>

				<div class="mb-0">
					<div>
						<button type="button" @click="addComment" class="btn btn-primary" :disabled="!commentForm.comment">Add Comment</button>
					</div>
				</div>
			</form>
		</b-modal>

		<b-modal size="lg" id="emailModal" centered :title="modalTitle" title-class="font-18" hide-footer>
			<form>
				<div class="mb-3">
					<label>To</label>
					<input v-model="emailForm.to" class="form-control" name="to" placeholder="To" readonly />
				</div>

				<div class="mb-3">
					<label>CC</label>
					<input v-model="emailForm.cc" class="form-control" name="cc" placeholder="CC (comma separated)" />
				</div>

				<div class="mb-3">
					<label>Subject</label>
					<input v-model="emailForm.subject" class="form-control" name="subject" placeholder="Subject" />
				</div>

				<div class="mb-3">
					<label>Body</label>
					<RichTextEditor cssClasses="form-control" v-model="emailForm.comment" />
				</div>

				<div class="mb-0">
					<div>
						<button type="button" @click="sendEmail" class="btn btn-primary" :disabled="isLoading">
							Send
							<i class="fab fa-telegram-plane ms-1"></i>
						</button>
					</div>
				</div>
			</form>
		</b-modal>

		<b-modal id="viewCommentModal" centered :title="modalTitle" title-class="font-18" hide-footer>
			<div v-if="isLoading" class="text-center">
				<b-spinner class="m-2" variant="primary" role="status"></b-spinner>
			</div>

			<div class="mb-3" v-if="recordNotFound">
				<p>No Comments Yet!</p>
			</div>

			<div v-else class="mb-3">
				<div class="card" v-for="(comment, commentIndex) in this.comments" :key="commentIndex">
					<div class="card-body">
						<div class="d-flex justify-content-between align-items-baseline">
							<p>
								Comment By:
								<span class="fw-bold font-size-12">{{ comment ? comment.staff : '-' }}</span>
							</p>
							<p>
								Comment Date:
								<span class="fw-bold font-size-12">{{ comment ? new Date(comment.created_at).toLocaleString().split(',')[0] : '-' }}</span>
								<br />
								<span v-if="comment.tag_name">
									Tag :
									<span class="fw-bold font-size-12">{{ comment.tag_name }}</span>
								</span>
							</p>
						</div>
						<p>
							{{ comment ? comment.comment : '-' }}
						</p>
					</div>
				</div>
			</div>
		</b-modal>
	</Layout>
</template>
<style scoped>
.btn-fixed {
	position: fixed;
	bottom: 0;
	right: 0;
	width: 100%;
	background: #ffffff;
	padding: 15px;
	text-align: right;
	z-index: 9;
}

.btn {
	position: relative !important;
}

.mntc_approvals_comment_count {
	position: absolute;
	right: -8px;
	top: -8px;
	font-size: 10px;
	width: 15px;
	height: 15px;
	background: rgb(212, 8, 8);
	border-radius: 50%;
}

.tr-disable td {
	background-color: rgba(0, 0, 0, 0.1);
}

.tr-disable td:not(:last-child) {
	opacity: 0.3;
	cursor: not-allowed;
}

.tr-disable input,
.tr-disable select,
.tr-disable .btn-send {
	pointer-events: none;
}

.cmntbox {
	margin-top: 10px;
	padding: 5px;
	border: 1px solid #ced4da;
	border-radius: 5px;
}

.cmntbox:first-child {
	margin-top: 0px;
}
</style>
